export const TRIP = '[Trip]'
export const GET_TRIPS = `${TRIP} GET_TRIPS`
export const SET_TRIPS = `${TRIP} SET_TRIPS`

export const TRIP_ACTIVITY = '[Trip Activity]'
export const CREATE_TRIP_ACTIVITY = `${TRIP_ACTIVITY} CREATE_TRIP_ACTIVITY`
export const SET_TRIP_ACTIVITIES = `${TRIP_ACTIVITY} SET_TRIP_ACTIVITIES`
export const GET_TRIP_ACTIVITIES = `${TRIP_ACTIVITY} GET_TRIP_ACTIVITIES`
export const UPDATE_TRIP_ACTIVITY = `${TRIP_ACTIVITY} UPDATE_TRIP_ACTIVITY`
